import { render, staticRenderFns } from "./addCollateDialog.vue?vue&type=template&id=cda85360&scoped=true"
import script from "./addCollateDialog.vue?vue&type=script&lang=js"
export * from "./addCollateDialog.vue?vue&type=script&lang=js"
import style0 from "./addCollateDialog.vue?vue&type=style&index=0&id=cda85360&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda85360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cda85360')) {
      api.createRecord('cda85360', component.options)
    } else {
      api.reload('cda85360', component.options)
    }
    module.hot.accept("./addCollateDialog.vue?vue&type=template&id=cda85360&scoped=true", function () {
      api.rerender('cda85360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/lending/addCollateDialog.vue"
export default component.exports